module.exports = __webpack_public_path__ + "img/shoe001.71c5909f.jpg";